import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ValidatorService} from '../../../../services/validator.service';
import {CountriesListService} from '../../../../services/countries-list.service';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {UtilService} from '../../../../util/util.service';
import {asciiValidator} from '../../../../validators/ascii-validator.directive';
import {requiredFieldValidator} from '../../../../validators/required-field-validator.directive';
import {whitelistCharacterValidator} from '../../../../validators/valid-character-validator.directive';
import {emailValidator} from '../../../../validators/email-validator.directive';
// TODO(RZ-2562): Replace legacy VO types (ContactVO) with SDK equivalents (ContactInformation)
import {ContactVO} from '../../../../generate/ContactVO';


@Component({
    selector: 'contact-info-edit',
    templateUrl: './contact-info-edit.component.html',
    styleUrls: ['./contact-info-edit.component.scss'],
    standalone: false
})
export class ContactInfoEditComponent implements OnInit {

  @Input()
  newDelegation: boolean;
  @Input()
  contactVO: ContactVO;
  @Output()
  contactVOOutput = new EventEmitter<ContactVO>();
  @Output()
  cancelOutPut = new EventEmitter<boolean>();
  editContactForm: FormGroup;
  countries: any[] = [];
  errors: ErrorVO;
  showOtherCountryElement: boolean;

  get name(): FormControl { return this.editContactForm.get('name') as FormControl; }
  get organizationName(): FormControl { return this.editContactForm.get('organizationName') as FormControl; }
  get streetAddress(): FormControl { return this.editContactForm.get('streetAddress') as FormControl; }
  get city(): FormControl { return this.editContactForm.get('city') as FormControl; }
  get state(): FormControl { return this.editContactForm.get('state') as FormControl; }
  get otherCountry(): FormControl { return this.editContactForm.get('otherCountry') as FormControl; }
  get postalCode(): FormControl { return this.editContactForm.get('postalCode') as FormControl; }
  get phone(): FormControl { return this.editContactForm.get('phone') as FormControl; }
  get fax(): FormControl { return this.editContactForm.get('fax') as FormControl; }

  constructor(private formBuilder: FormBuilder, private validator: ValidatorService, private util: UtilService, private countriesListService: CountriesListService) {
  }


  ngOnInit() {
    this.countries = this.countriesListService.countriesList;
    this.createForm();
  }

  displayValidationError(controlName: string): boolean {
    return this.editContactForm.contains(controlName)
      && !this.editContactForm.get(controlName).valid
      && this.editContactForm.get(controlName).touched
  }

  onSubmit() {
    const formValue = this.editContactForm.value;

    let modifiedContact = {
      name: this.util.returnNullIfEmpty(formValue.name),
      organizationName: this.util.returnNullIfEmpty(formValue.organizationName),
      email: this.util.returnNullIfEmpty(formValue.email),
      phone: this.util.returnNullIfEmpty(formValue.phone),
      fax: this.util.returnNullIfEmpty(formValue.fax),
      address: this.countriesListService.buildAddressFromForm(formValue)
    };
    
    // Remove null properties to comply with OpenAPI schema (Optional & Not Nullable)
    modifiedContact = this.util.removeNullProperties(modifiedContact) as any;

    this.validator.validateContactInfo(modifiedContact).subscribe(data => {
      if (data == null) {
        this.contactVO.address = modifiedContact.address;
        this.contactVO.name = modifiedContact.name;
        this.contactVO.organizationName = modifiedContact.organizationName;
        this.contactVO.email = modifiedContact.email;
        this.contactVO.phone = modifiedContact.phone;
        this.contactVO.fax = modifiedContact.fax;
        this.contactVOOutput.emit(this.contactVO);
      } else {
        this.errors = data;
      }
    });

  }

  cancel() {
    this.cancelOutPut.emit(true);
  }


  displayServerValidationError(field: string): string[] {
    let error: ErrorVO = this.util.getFieldError(field, this.errors);
    if (error != null) {
      return error.errorMessages;
    }
  }

  displayAddressValidationError(field: string): string[] {
    let error: ErrorVO = this.util.getFieldError("address", this.errors);
    if (error != null) {
      let fieldError: ErrorVO = this.util.getFieldError(field, error);
      if (fieldError != null) {
        return fieldError.errorMessages;
      }
    }
  }

  private createForm() {
    if (this.contactVO == null) {
      this.contactVO = {};
    }

    if (this.contactVO.address == null) {
      this.contactVO.address = {};
    }


    this.editContactForm = this.formBuilder.group({
      name: [this.contactVO.name, [whitelistCharacterValidator]],
      organizationName: [this.contactVO.organizationName, [whitelistCharacterValidator]],
      streetAddress: [this.contactVO.address.streetAddress, [requiredFieldValidator, whitelistCharacterValidator]],
      city: [this.contactVO.address.city, [whitelistCharacterValidator]],
      state: [this.contactVO.address.state, [whitelistCharacterValidator]],
      countryName: [this.countriesListService.getCountry(false, this.contactVO.address), [requiredFieldValidator]],
      otherCountry: [this.countriesListService.getCountry(true, this.contactVO.address), [whitelistCharacterValidator]],
      postalCode: [this.contactVO.address.postalCode, [whitelistCharacterValidator]],
      email: [this.contactVO.email, [requiredFieldValidator, emailValidator]],
      phone: [this.contactVO.phone, [requiredFieldValidator, whitelistCharacterValidator]],
      fax: [this.contactVO.fax, [whitelistCharacterValidator]],
    });
    this.showOtherElement();
  }

  showOtherElement() {
    this.showOtherCountryElement = this.editContactForm.value.countryName === "other";
  }

}
